import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import ErrorPages from 'src/pages/_error';

export default function JobsByTitle(props: any) {
  return <ErrorPages statusCode={410} />;
}

export const getServerSideProps: GetServerSideProps<any> = async ({
  query,
  req,
  res,
}: GetServerSidePropsContext) => {
  res.statusCode = 410;
  return {
    props: {}, // will be passed to the page component as props
  };
};
